import './vendor/RequestAnimationFrame'; // eslint-disable-line
import './vendor/IntersectionObserver'; // eslint-disable-line

import store from './util/store';
import stats from './util/stats';

import RafManager from './util/RafManager';
import Highway from '@dogstudio/highway';
import PageRenderer from './navigation/PageRenderer';
import PageTransition from './navigation/PageTransition';
import LinksTransition from './navigation/LinksTransition';
import EasterEggs from './animation/EasterEggs';
import PageAnimation from './animation/PageAnimation';
import NavbarAnimation from './animation/NavbarAnimation';

window.addEventListener('load', () => {
  store.setGlobalVars();
  window.addEventListener('resize', () => {
    store.setGlobalVars();
  });

  const $main = document.querySelector('main');
  RafManager.addQueue(() => {
    store.scrollTop = $main.scrollTop;
  });

  const navbarAnimation = new NavbarAnimation();
  navbarAnimation.createFadeIn();

  const easterEggs = new EasterEggs();
  // easterEggs.onKonami();
  easterEggs.onSpacebar();

  const core = new Highway.Core({
    renderers: { page: PageRenderer, single: PageRenderer, archive: PageRenderer, links: PageRenderer },
    transitions: { default: PageTransition, links: LinksTransition },
  });

  window.redirect = function(url) {
    core.redirect(url);
  };

  window.attach = function(links) {
    console.log(links);
    core.attach(links);
  }

  const detachFromCore = '.js-detach-from-core';
  core.detach(document.querySelectorAll(detachFromCore));

  core.on('NAVIGATE_IN', ({ to }) => {
    if (document.body.classList.contains('locked')) {
      to.page.body.classList.add('locked');
    }

    to.page.body.classList.remove('js-not-loaded');
    document.body.classList = to.page.body.classList;

    // Adapting meta tags
    [].forEach.call(to.page.head.childNodes, node => {
      var documentNode = false;
      switch (node['nodeName']) {
        case 'META':
          if (node.hasAttribute('property')) documentNode = document.querySelector('meta[property=\'' + node.getAttribute('property') + '\']');
          else if (node.hasAttribute('name')) documentNode = document.querySelector('meta[name=\'' + node.getAttribute('name') + '\']');

          if (documentNode) documentNode.setAttribute('content', node['content']);
          break;
        case 'LINK':
          if (node.hasAttribute('rel') && 'canonical' === node.getAttribute('rel')) documentNode = document.querySelector('link[rel=\'' + node.getAttribute('rel') + '\']');
          else if (node.hasAttribute('rel') && 'icon' === node.getAttribute('rel') && node.hasAttribute('sizes')) documentNode = document.querySelector('link[rel=\'' + node.getAttribute('rel') + '\'][sizes=\'' + node.getAttribute('sizes') + '\']');
          else if (node.hasAttribute('rel') && 'apple-touch-icon-precomposed' === node.getAttribute('rel')) documentNode = document.querySelector('link[rel=\'' + node.getAttribute('rel') + '\']');

          if (documentNode) documentNode.setAttribute('href', node['href']);
          break;
        default:
          break;
      }
    });
  });

  core.on('NAVIGATE_END', ({ to, location }) => {
    core.detach(document.querySelectorAll(detachFromCore));

    stats.track(location.href, to.page.title);
  });

  new PageAnimation(null, document.querySelector('.section'), () => {
    navbarAnimation.fadeIn.play();
  });

  stats.track(window.location, document.title);

  document.body.classList.remove('js-not-loaded');
});



// WEBPACK FOOTER //
// ./scripts/main.js